<template>
    <div class="app-container">
      <BjPage
        ref="BjPage"
        :query-params="queryParams"
        :col-span="colSpan"
        :label-width="'80px'"
        :get-action="queryApi"
        :serial="serial"
        :selection="selection"
        @handleSelectionChange="handleSelectionChange"
        @showSetting="SortableTable.show"
        @header-dragend="SortableTable.handleHeaderDragend"
        @header-contextmenu="SortableTable.handleHeaderContextmenu"
      >
        <template v-slot:baseForm>
          <el-col :span="colSpan">
            <!-- <el-form-item :label="$t('AccountManagement.customer.companyName')" prop="companyName">
              <BjInput v-model="queryParams.companyName" :placeholder="$t('AccountManagement.customer.companyName')" @keyup.enter.native="handleQuery" /> 
            </el-form-item> -->
            <el-form-item :label="$t('AccountManagement.customer.name')" prop="cusId">
              <BjSelectLov v-model="queryParams.cusId" :option-list="customerList" :placeholder="$t('customerNameText')" />
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('billingPage.Sales')" prop="csgSales">
              <BjInput v-model="queryParams.csgSales" :placeholder="$t('billingPage.Sales')" @keyup.enter.native="handleQuery" /> 
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('workOrderList.Customer')" prop="csgCustomer">
              <BjSelectLov v-model="queryParams.csgCustomer" :option-list="customerNameList" :placeholder="$t('workOrderList.Customer')"/>
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagement.customer.status')" prop="enabled">
              <BjSelectLov v-model="queryParams.enabled" :option-list="STATUS_ENABLED_NUM" :placeholder="$t('AccountManagement.customer.status')"/> 
            </el-form-item
          ></el-col>
        </template>
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column
              v-if="col.prop !== 'bjTableAction'"
              :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
              :prop="col.prop"
              :label="col.label"
              :width="col.width || 'auto'"
              :fixed="col.fixed || false"
              align="center"
              class-name="item"
            >
              <template slot-scope="scope">
                <span v-if="col.prop === 'enabled'">
                  {{ $t(STATUS_ENABLED_NUM.bjGet(scope.row.enabled)) }}
                </span>
                <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="col.prop === 'bjTableAction'"
              :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
              :prop="col.prop"
              :label="col.label"
              :width="col.width || 'auto'"
              :fixed="col.fixed || 'right'"
              align="center"
            >
              <template slot-scope="props">
                <el-button type="text" class="edit-btn" @click="onDetail(props.row)">{{ $t('viewText') }}</el-button>
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>
    </div>
  </template>
  <script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { userApi } from '@/api';
  import { STATUS_ENABLED_NUM } from '@/utils/constants';
  import dialogCompany from '../account/components/DialogCompany';

  export default {
    name: 'BusinessUserDepartmentBackup',
    components: { dialogCompany },
    mixins: [pageMiXin],
    data() {
      return {
        STATUS_ENABLED_NUM,
        selection: false,
        queryApi: userApi.getUserfileList,
        // 查询参数
        queryParams: {
          companyName: null,
          cusId: null,
          csgSales: null,
          csgCustomer: null,
          enabled: null,
        },
        labelList: [
          { label: this.$t('AccountManagement.customer.companyName'), prop: 'companyName', isCheck: true, disabled: false, width: 125 },
          { label: this.$t('AccountManagement.customer.status'), prop: 'enabled', isCheck: true, disabled: false, width: 100 },
          { label: this.$t('billingPage.Sales'), prop: 'csgSales', isCheck: true, disabled: false, width: 125 },
          { label: this.$t('workOrderList.Customer'), prop: 'csgCustomer', isCheck: true, disabled: false, width: 125 },
          { label: this.$t('AccountManagement.backup.Contract'), prop: 'contractNum', isCheck: true, disabled: false },
          { label: this.$t('AccountManagement.backup.Rate'), prop: 'rateCardNum', isCheck: true, disabled: false },
          { label: this.$t('AccountManagement.backup.Terms'), prop: 'termsAndConditionsNum', isCheck: true, disabled: false },
          { label: this.$t('AccountManagement.backup.Credit'), prop: 'creditApplicationNum', isCheck: true, disabled: false },
          { label: this.$t('AccountManagement.backup.Inbound'), prop:'inboundChecklistNum', isCheck: true, disabled: false },
          { label: this.$t('AccountManagement.backup.Internal'), prop: 'internalHandoverFormNum', isCheck: true, disabled: false },
          { label: this.$t('AccountManagement.backup.IT'), prop: 'itChecklistNum', isCheck: true, disabled: false },
          { label: this.$t('AccountManagement.backup.Others'), prop: 'othersNum', isCheck: true, disabled: false },
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 100 },
        ],
        // 客服下拉列表
        customerNameList:[],
      };
    },
    created(){
      // 获取客服下拉框数据
      this.getCustomerList()
    },
    methods: {
      // 获取客服下拉数据
      getCustomerList(){
        userApi.getUserList({enabled: true,customerType: 'P',deptAbbr:'Customer Service'}).then(res=>{
          this.customerNameList = res.content.map(item => {
            return { label: item.realName, value: item.realName };
          });
        })
      },
      
      /* 跳转页面 */
      onDetail(row) {
        this.$router.push({
          name: 'BusinessUserDepartmentBackupDetail',
          query: { 
            parentId: row.id ,
            cusId: row.cusId ,
          },
        });
      },
    },
  };
  </script>
  <style scoped>
  ::v-deep .bj-page .el-form-item__label{
    display: none;
  }
  </style>
